import { onImageTextInput } from '@utils/component-framework';
import { NoSSR } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useTaskContext } from '../../context.js';
import { useInputState } from '../../hook.use-input-state.js';
import { TextInput } from '../write-answers.in-text/atom.text-input.js';
import { useMinimumTextInputLength } from './context.js';
import { tokens, wrapper } from './input.text.style.js';
import { jsx } from 'react/jsx-runtime';

function OnImageTextInput(props) {
  const context = useTaskContext();
  const minimumInputLength = useMinimumTextInputLength();
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => onImageTextInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = evt => {
    update(props.taskEntryKey, props.input.id, {
      type: "on-image-text",
      text: evt.currentTarget.value
    });
  };
  const baseState = useInputState(props.input, inputEntry);
  const state = baseState === "incorrect" && props.facitType === "should-have" ? "should-have" : baseState;
  const value = props.facitType === "should-have" && state === "should-have" ? props.input.validation.correctAnswers.find(answer => onImageTextInput.cleanText(answer, props.input.validation) !== onImageTextInput.cleanText(inputEntry?.text ?? "", props.input.validation)) : inputEntry?.text;
  return /*#__PURE__*/jsx(NoSSR, {
    children: /*#__PURE__*/jsx("div", {
      className: wrapper,
      style: tokens.__override({
        x: `${props.input.placement.x * 100}%`,
        y: `${props.input.placement.y * 100}%`,
        scale: props.scale
      }),
      "data-pencil-alignment": minimumInputLength >= 8 ? "left" : "center",
      children: /*#__PURE__*/jsx(TextInput, {
        value: value,
        state: state,
        enterKeyHint: "next",
        readOnly: context === "facit" || context === "readonly",
        onChange: onChange,
        alignment: minimumInputLength > 1 ? "left" : "center",
        minimumInputLength: minimumInputLength,
        widthStrategy: "fixed"
      })
    })
  });
}

export { OnImageTextInput };
//# sourceMappingURL=input.text.js.map
